import React from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import tapOrClick from 'react-tap-or-click'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import SubsListIcon from 'react-icons/lib/fa/list'
import classnames from 'classnames'
import '../../../stylesheets/ControllerDashboard.css'
import { authRedirect } from "../../../dataHelpers/authenticationHelpers"
import { AddDiscountLabel } from "../../ui"

class DiscountLabelSetting extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: '1',
            errors: []
        }
    }

    render() {

        return (<div>
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                        >
                            <AddPlanIcon />&ensp;Create Discount Level
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/editdiscountlabel`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Discount Level
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/discountlabellist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Available Discount Levels
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <AddDiscountLabel />
        </div>)
    }
}
export default DiscountLabelSetting



// WEBPACK FOOTER //
// ./src/components/pages/subscription/DiscountLabelSetting.js